import React from "react"
import { Modal as AntModal, ModalProps } from "antd"
import { Flex } from "rebass"
import { css, useTheme } from "@emotion/react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro"
import { BodyTextRegular, BodyTextSemibold } from "./typography/text"
import { Heading3, Heading4 } from "./typography/headings"
import { desktopContainer, mobileContainer } from "../theme"

const headerStyle = css`
  flex-direction: column;
  gap: 8px;
  width: 100%;
`

type Props = {
  isVisible: boolean
  onClose?: () => void
  children: any
  title?: string
  subtitle?: string
  subtitleSpan?: React.ReactNode
} & ModalProps

export const Modal = ({
  isVisible,
  onClose,
  children,
  title,
  subtitle,
  subtitleSpan,
  ...rest
}: Props) => {
  const theme = useTheme()

  const modalContainerStyle = css`
    flex-direction: column;
    width: 100%;
    overflow: visible;
    padding-left: 4px;
    padding-right: 4px;

    ${theme.bp.mobile} {
      max-height: 100vh;
    }

    /* TODO */
    /* There is an issue where on large screens, scrollbar is always visible and takes extra space */
    /* Hide scrollbar on large screens for IE, Edge and Firefox */
    ${theme.bp.hd} {
      -ms-overflow-style: none; /* IE and Edge */
      scrollbar-width: none; /* Firefox */
    }

    /* TODO */
    /* There is an issue where on large screens, scrollbar is always visible and takes extra space */
    /* Hide scrollbar on large screens for Chrome, Safari and Opera */
    ::-webkit-scrollbar {
      ${theme.bp.hd} {
        display: none;
      }
    }
  `

  const closeIcon = (
    <BodyTextSemibold color={theme.colors.primary}>
      <FontAwesomeIcon icon={solid("x")} />
    </BodyTextSemibold>
  )

  return (
    <AntModal
      zIndex={10000000}
      centered
      closeIcon={closeIcon}
      open={isVisible}
      onCancel={onClose}
      footer={null}
      {...rest}
    >
      <Flex css={modalContainerStyle} mt="32px">
        <Flex css={headerStyle} mb="16px">
          {title && (
            <>
              <Heading3 color={theme.colors.primary} css={desktopContainer}>
                {title}
              </Heading3>
              <Heading4 color={theme.colors.primary} css={mobileContainer}>
                {title}
              </Heading4>
            </>
          )}
          {(subtitle || subtitleSpan) && (
            <BodyTextRegular color={theme.colors.primary}>
              {subtitle} {subtitleSpan}
            </BodyTextRegular>
          )}
        </Flex>
        {children}
      </Flex>
    </AntModal>
  )
}
